<template>
  <div id="app">
    <div class="btn-group" role="group" aria-label="Basic example">
      <button type="button" class="btn btn-secondary" @click="setLang('cn')">
        简
      </button>
      <button type="button" class="btn btn-secondary" @click="setLang('en')">
        英
      </button>
      <button type="button" class="btn btn-secondary" @click="setLang('tw')">
        繁
      </button>
    </div>
    <img alt="Yufa logo" src="./assets/Yufa_LogoBig_CompanyName.svg" />
    <div id="nav">
      <router-link to="/">{{ $t("home12") }}</router-link> |
      <router-link to="/about_us">{{ $t("aboutus12") }}</router-link> |
      <router-link to="/machinery">{{ $t("machinery12") }}</router-link> |
      <router-link to="/contact_us">{{ $t("contactus12") }}</router-link>
    </div>
    <HelloWorld msg="Welcome to Your Vue.js App" />
    <footer class="bg-dark">
      <div class="container">
        <div class="row footer-info-box">
          <div class="col-12 col-sm-6 company-logo">
          <img alt="Yufa logo" src="./assets/Yufa_LogoBig_CompanyName-2.svg" />
          </div>
          <div class="col-12 col-sm-6 footer-info">
            <div class="icon-box">
              <img src="./assets/img/icons/Email.svg" />
              <a href="mailto:UfaServerMail@gmail.com">UfaServerMail@gmail.com</a>
            </div>
            <div class="icon-box">
              <img src="./assets/img/icons/Phone.svg" />
              <a href="tel:+88677877207">07-7877207</a>
            </div>
<!--
            <div class="icon-box">
              <img src="./assets/img/icons/Fax.svg" />
              <a href="tel:+88677872576">07-7872576</a>
            </div>
-->
            <div class="icon-box-map">
              <img src="./assets/img/icons/Map.svg" />
              <a
                href="https://goo.gl/maps/bRxHPhfL1L3jMtXk7"
                target="_blink"
                rel="noopener noreferrer"
              >
                {{ $t("FirmAddr1") }}<br />{{ $t("FirmAddr2") }}<br />{{
                  $t("FirmAddr3")
                }}<br />{{ $t("FirmAddr4") }}</a
              >
            </div>
          </div>
<!--           <div class="col-12 col-sm-6 social-media">
            <p>FOLLOW US ON:</p>
            <div>
              <a href="line://ti/p/%40rxi0896y">
                <img src="./assets/img/icons/line.svg" />
                <span>Line</span>
              </a>
            </div>
          </div>
 -->
        </div>
      </div>
    </footer>
    <a href="javascript:goTop();" id="gotop">
      <i class="fa-solid fa-angle-up"></i>
    </a>
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import VanillaTilt from 'vanilla-tilt';
import {} from "./mouse.js";

export default {
  name: "App",
  components: {
    HelloWorld
  },
  data() {
    return {
      selected: "",
    };
  },
  methods: {
    setLang: function (lang) {
      this.$store.dispatch("setLang", lang);
    },
  },
};
</script>

<style lang="stylus">
.pro-box
  -webkit-transform-style:  preserve-3d;
  transform-style:  preserve-3d;
  -webkit-transform:  perspective(1000px);
  transform:  perspective(1000px);
  border: 3px solid #014fa1;
  margin: 15vmin 0vmin;
  box-shadow: 10px 10px 20px 0px rgb(1 79 161);

#app
  font-family: 'DFKai-sb', serif;
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing:  grayscale
  text-align: center
  color:  #2c3e50
  margin-top: 60px;

body
  //background: -webkit-linear-gradient(left, #acaead, #ededed, #969186, #9e9a90, #fff, #9e9a90, #969186, #ededed, #acaead);
  background: -webkit-linear-gradient(left, #828282, #bdc0ba, #fffffb, #fff, #fffffb, #bdc0ba, #828282);
  //background: linear-gradient(15deg, #0151a3, transparent), linear-gradient(to right, #060C44, transparent);
  font-size:  18px;
  font-weight:  400;
  text-align: left;
  line-height:  1.5;

html
  font-family:  sans-serif;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: transparent;
  line-height: 1.5;
  width:  auto;
  height: 230%;

:root
  --blue:#5e72e4;
  --indigo:#5603ad;
  --purple:#8965e0;
  --pink:#f3a4b5;
  --red:#f5365c;
  --orange:#fb6340;
  --yellow:#ffd600;
  --green:#2dce89;
  --teal:#11cdef;
  --cyan:#2bffc6;
  --white:#fff;
  --gray:#8898aa;
  --gray-dark:#32325d;
  --light:#ced4da;
  --lighter:#e9ecef;
  --primary:#5e72e4;
  --secondary:#f4f5f7;
  --success:#2dce89;
  --info:#11cdef;
  --warning:#fb6340;
  --danger:#f5365c;
  --light:#adb5bd;
  --dark:#212529;
  --default:#172b4d;
  --white:#fff;
  --neutral:#fff;
  --darker:black;
  --breakpoint-xs:0;
  --breakpoint-sm:576px;
  --breakpoint-md:768px;
  --breakpoint-lg:992px;
  --breakpoint-xl:1200px;
  --font-family-sans-serif:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';
  --font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,'Liberation Mono','Courier New',monospace;

button
  font-size:  3vmin;
  font-family: Lisu;
  text-align: center;
  float:  right;
  background-color: transparent;
  border-color: #014FA1;
  border-radius: 30vmin;
  margin-left: 1vmin;
  margin-top: -2vmin;

.bg-dark
  background-color: -webkit-linear-gradient(left, #acaead, #fff, #969186, #fff, #80807f)!important;
  margin-top: 25vmin

footer
  padding:  2% 0;
  color:  #fff;
  border-top: 1.5px solid rgba(255,255,255,.5);

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section
  display: block;

.container
  width:  100%
  margin-right: auto;
  margin-left:  auto;
  padding-right:  15px;
  padding-left: 15px;

.container .row
  position: relative;
  top: 15vmin;

footer .footer-info-box
  font-size:  40%;
  color:  #4158d0;
  margin-top: -30vmin;

.row
  display:  flex;
  margin-right: -15px;
  margin-left:  -15px;
  flex-wrap:  wrap;

footer .footer-info
  display:  flex;
  flex-direction: column;

@media (min-width:  326px)
  .col-sm-6
    margin-top: 10vmin;
    max-width:  50%
    flex:0 0 50%

.col-12
  max-width:  100%;
  flex: 0 0 100;

footer .icon-box
  display:  flex;
  margin: 0vmin 0vmin 0vmin 0vmin;

footer .icon-box img
  width:  5vmin;
  height: 5vmin;
  margin: 0.5vmin 2vmin 0vmin 3vmin;//top,left,bottom,right

footer .icon-box-map
  display: flex;
  margin: 0vmin 0vmin 0vmin 0vmin;

footer .icon-box-map img
  width:  5vmin;
  height: 5vmin;
  margin: 2vmin 2vmin 0vmin 3vmin;

//footer .social-media img
//  width:  10%;
//  height: 10%;
//  margin-left:  -10%
//  margin-top: 2%;

footer .company-logo img
  width:  60vmin;

//footer .social-media span
//  margin-left:  10px;

img
  vertical-align: middle;
  border-style: none;
  width:  90vmin;
  height: 28vmin;

footer .footer-info-box a
  color:  #4158d0;
  text-align: left;
  font-size:  2.5vmin;
  font-family: 'Libre Franklin', sans-serif;
  height: 50%;
  margin-top: 1vmin;

a
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
  color:  #337ab7;
  font-size:  3vmin;
  margin: 5vmin 5vmin;

footer .footer-info-box p
  font-size:  18px;
  margin-bottom:  1%;

p
  margin-top: 0;
  margin-bottom:  1rem;

*, ::after, ::before
  box-sizing: border-box;

#gotop {
  display: block;
  background-color: #101348;
  color: #0a104d;
  position: fixed;
  right: 0%;
  bottom: 0%;
  width: 6vmin;
  height: 6vmin;
  text-align: center;
  line-height: 6vmin;
  font-size: 3vmin;
  z-index: 99;
  border-radius: 10vmin;
  border: 3px solid #014fa1;
}

.fa-solid {
  display: inline-block;
  font: normal normal normal 3vmin/2 FontAwesome;
  text-rendering: auto;
  color: #fff
  -webkit-font-smoothing: antialiased;
}

.fa-angle-up:before {
  content: "\f106";
}

#cursor {
  width:  30px;
  height: 30px;
  position: absolute;
  z-index:  999999999;
  pointer-events: none;
  opacity:  0; 
}

#cursor .waku, #cursor {
  z-index:  -9999999999;
}

#cursor .holder {
  width:  100%;
  height: 100%;
  position: relative;
  -webkit-transform:  translate(-1.5px, -1.5px);
  transform:  translate(-1.5px, -1.5px);
}

#cursor .waku {
  width:  100%;
  height: 100%;
  position: absolute;
  border: 1px solid #fff;
  transform:  rotate(45deg);
  -webkit-box-shadow: 0 0 18px 0 rgb(50 50 50 / 15%);
  -moz-box-shadow:  0 0 18px 0 rgba(50, 50, 50, 0.15);
  box-shadow: 0 0 18px 0 rgb(50 50 50 / 15%);
  transition: .1s;
  -o-transition:  .1s;
  -moz-transition:  .1s;
  -webkit-transition: .1s;
  -ms-transition: .1s;
}

#cursor .dot {
  top:  12px;
  left: 12px;
  width:  6px;
  height:  6px;
  position: absolute;
  border-radius:  100%;
  background-color: #fff;
  transition: .5s ease-in-out;
  -o-transition:  .5s ease-in-out;
  -moz-transition:  .5s ease-in-out;
  -webkit-transition: .5s ease-in-out;
  -ms-transition: .5s ease-in-out;
  -webkit-box-shadow: 0 0 10px 1px rgb(0 0 0 / 20%);
  -moz-box-shadow:  0 0 10px 1px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 10px 1px rgb(0 0 0 / 20%);
}
</style>
